export const proctoringOptionKeys = {
  all: 'option_proctoring_video_image_stream',
  image: 'option_proctoring_image_stream',
  none: 'option_proctoring_logs_only'
};

export const simulationProctoringOptionKeys = {
  all: 'option_simulation_camera_audio',
  none: 'option_simulation_no_camera_audio'
};

export const chatOptionKeys = {
  all: 'option_chat_both',
  fiscal_to_student: 'option_chat_proctor_only',
  none: 'option_chat_none'
};

export const imageIntervalOptionKeys = {
  30000: 'option_seconds_30',
  15000: 'option_seconds_15'
};

export const translateOption = (t, keys, option) =>
  t(keys[option.id] || option.name);

export const getTranslatedOptionName = (t, keys, options = [], id) => {
  const option = options.find((item) => item.id === id);
  return option ? translateOption(t, keys, option) : t('summary_not_informed');
};
